import React, { useEffect } from 'react';
import { FaPlaneDeparture, FaCalendarAlt, FaUserFriends, FaExchangeAlt } from 'react-icons/fa';

// --- CSS STYLES FOR THE BOX INPUT ---
// These styles are specific to this search panel design.
const styles = `
    .search-box-flight {
        background-color: #f8f9fa;
        border-radius: 8px;
        padding: 0.75rem 1rem;
        border: 1px solid #dee2e6;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }
    .search-box-flight:focus-within {
        border-color: var(--primary);
        box-shadow: 0 0 0 0.25rem rgba(var(--bs-primary-rgb), 0.25);
    }
    .search-box-flight .form-label {
        font-size: 0.75rem;
        font-weight: 600;
        text-transform: uppercase;
        color: #6c757d;
        margin-bottom: 0.25rem;
    }
    .search-box-flight .form-control {
        border: none;
        padding: 0;
        background-color: transparent;
        font-weight: 500;
        font-size: 1rem;
    }
    .search-box-flight .form-control:focus {
        box-shadow: none;
    }
`;

// --- Reusable BoxInput Component (defined locally) ---
const BoxInput = ({ icon, label, children }) => (
    <div className="search-box-flight d-flex align-items-center">
        {icon && <div className="me-3 fs-5 text-muted">{icon}</div>}
        <div className="flex-grow-1">
            <label className="form-label d-block">{label}</label>
            {children}
        </div>
    </div>
);

const SearchFlightPanel2 = () => {
    // Effect to inject the styles into the document head
    useEffect(() => {
        const styleTag = document.createElement('style');
        styleTag.innerHTML = styles;
        document.head.appendChild(styleTag);
        return () => { document.head.removeChild(styleTag); };
    }, []);

    return (
        <div>
            {/* Oneway/Roundtrip Tabs */}
            <ul className="nav nav-pills mb-4">
                <li className="nav-item"><a className="nav-link active" href="#">ONEWAY</a></li>
                <li className="nav-item"><a className="nav-link" href="#">ROUNDTRIP</a></li>
            </ul>

            <div className="row g-3">
                {/* From Input */}
                <div className="col-lg">
                    <BoxInput label="Leaving from" icon={<FaPlaneDeparture />}>
                        <input type="text" className="form-control" placeholder="Select city" />
                    </BoxInput>
                </div>
                
                {/* To Input */}
                <div className="col-lg">
                    <BoxInput label="Going to" icon={<FaExchangeAlt />}>
                        <input type="text" className="form-control" placeholder="Select city" />
                    </BoxInput>
                </div>

                {/* Date Input */}
                <div className="col-lg">
                    <BoxInput label="Choose Date" icon={<FaCalendarAlt />}>
                        <input type="date" className="form-control" />
                    </BoxInput>
                </div>

                {/* Travellers Input */}
                <div className="col-lg">
                    <BoxInput label="Travellers" icon={<FaUserFriends />}>
                        <select className="form-select border-0 p-0 bg-transparent">
                            <option>1 Adult</option>
                            <option>2 Adults</option>
                        </select>
                    </BoxInput>
                </div>
                
                {/* Search Button */}
                <div className="col-lg-auto d-grid">
                    <button className="btn btn-primary btn-lg h-100 px-5">Search Flights</button>
                </div>
            </div>
        </div>
    );
};

export default SearchFlightPanel2;